export const EMBED_ROOT_CLASS_SELECTOR = "js-srf-meteo-web";
